import {Injectable} from '@angular/core';
// @ts-ignore
import * as SDK from 'piopiyjs';
import {Observable} from "rxjs";
import {CallingDataService} from "./calling-data.service";

@Injectable({
  providedIn: 'root'
})
export class TelService extends CallingDataService {

  //sdk: SDK;
  sdk = new SDK({
    name: ' Vol-mint Technologies',
    debug: false,
    autoplay: true,
    ringTime: 60
  });
  trying: any;
  ringing: any;
  answered: any;
  callStream: any;

  constructor(private callingService: CallingDataService) {
    super();
  }

  handleLoginProcess(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('login', (response: object) => {
        observer.next(response);
        observer.complete();
      });
      this.sdk.on('loginFailed', (response: object) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  handleMakeCallProcess(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('trying', (response: object) => {
        observer.next(response);
        observer.complete();
        this.callingService.shareActivityData(response, 'TRYING');
      });
      this.sdk.on('ringing', (response: object) => {
        observer.next(response);
        observer.complete();
        this.callingService.shareActivityData(response, 'RINGING');
      });
      this.sdk.on('answered', (response: object) => {
        observer.next(response);
        observer.complete();
        this.callingService.shareActivityData(response, 'ANSWERED');
      });
      this.sdk.on('callStream', (response: object) => {
        observer.next(response);
        observer.complete();
        this.callingService.shareActivityData(response, 'CALL_STREAM');
      });
      this.sdk.on('hangup', (response: object) => {
        observer.next(response);
        observer.complete();
        this.callingService.shareActivityData(response, 'HANG_UP');
      });
      this.sdk.on('ended', (response: object) => {
        observer.next(response);
        observer.complete();
        this.callingService.shareActivityData(response, 'ENDED');
      });
      this.sdk.on('transfer', (response: object) => {
        observer.next(response);
        observer.complete();
        this.callingService.shareActivityData(response, 'TRANSFER');
      });
      this.sdk.on('hold', (response: object) => {
        observer.next(response);
        observer.complete();
        this.callingService.shareActivityData(response, 'HOLD');
      });
      this.sdk.on('unhold', (response: object) => {
        observer.next(response);
        observer.complete();
        this.callingService.shareActivityData(response, 'UN_HOLD');
      });
    });
  }

  handleIncomingCallStream(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('callStream', (response: object) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  /*answerIncomingCallStream(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('callStream', (response: object) => {
        observer.next(response);
        observer.complete();
      });
    });
  }*/

  handleCallTransferProcess(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('transfer', (response: object) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  handleCallHangupProcess(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('hangup', (response: object) => {
        observer.next(response);
        observer.complete();
      });
      this.sdk.on('ended', (response: object) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  handleHoldProcess(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('hold', (response: object) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  handleUnHoldProcess(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('unhold', (response: object) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  handleRTCStats(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('RTCStats', (response: object) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  handleLogoutProcess(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('logout', (response: object) => {
        observer.next(response);
        observer.complete();
      });
    });
  }

  handleInComingCall(): Observable<any> {
    return new Observable(observer => {
      const eventHandler = (response: object) => {
        observer.next(response);
      };
      this.sdk.on('inComingCall', eventHandler);
      return () => {
        this.sdk.off('inComingCall', eventHandler);
      };
    });
  }

  handleError(): Observable<any> {
    return new Observable(observer => {
      this.sdk.on('error', (response: object) => {
        observer.next(response);
        observer.complete();
      });
    });
  }
}
